import { BlockTimesProximityActions } from "../../../../../../ngapp/src/app/modules/admin/blockTimesAndProximity/state/block-times-proximity.actions";
import { AdminUsersActions } from "../../../../../../ngapp/src/app/admin-user-features/state/admin-users.actions";
import { Subscription } from "rxjs";
import { UserAction } from "../../../../../../ngapp/src/app/user/state/user.action";
angular.module('autoremind.users', [])
    .controller('autoremind.users.ScreenController', 
// Setup dependencies
['$rootScope', '$scope', '$q', '$location', '$route', '$timeout', '$window', '$filter', 'logger', 'accountService', 'userProfile', 'dialogs', '$routeParams', '$enhancedHttp', 'eventSharingService',
    'storeDowngraded', 'blockTimesProximitySelectorsDowngraded', 'userSelectorsDowngraded',
    function ($rootScope, $scope, $q, $location, $route, $timeout, $window, $filter, logger, accountService, userProfile, dialogs, $routeParams, $enhancedHttp, eventSharingService, storeDowngraded, blockTimesProximitySelectorsDowngraded, userSelectorsDowngraded) {
        // Initialize
        userProfile.initalizeViewModel();
        if (!angular.isDefined(userProfile.viewModel.views.admin)) {
            // This is the first time opening the admin view, so initialize
            userProfile.viewModel.views.admin = {};
        }
        if (!angular.isDefined(userProfile.viewModel.views.admin.users)) {
            // This is the first time opening the admin.users view, so initialize
            userProfile.viewModel.views.admin.users = {};
        }
        $scope.viewModel = userProfile.viewModel.views.admin.users;
        $scope.viewModel.selectedUser = null;
        // This will ensure tabs are hidden if user not valid
        $scope.userId = 0;
        $scope.viewModel.userId = 0;
        $scope.viewModel.detailsVisible = false;
        $scope.viewModel.usersList = null;
        $scope.viewModel.updateMode = false;
        $scope.viewModel.newMode = false;
        $scope.viewModel.changed = false;
        $scope.viewModel.saving = false;
        $scope.viewModel.permission = {};
        $scope.viewModel.permission.changed = false;
        $scope.viewModel.permission.saving = false;
        $scope.viewModel.permission.newMode = true;
        $scope.viewModel.permission.updateMode = false;
        // Check if initially had 2-way permission
        $scope.viewModel.hasPreviousTwoWayPermission = false;
        $scope.viewModel.countries = {};
        $scope.viewModel.selectedUserInfo2 = {};
        // Used by view to highlight the login button for current host
        $scope.host = $location.host();
        $scope.viewModel.blockTimes = [];
        $scope.viewModel.isBlockTimeOrProximityChanged = false;
        $scope.viewModel.appointmentProximity = undefined;
        //Max Voice Retries
        $scope.viewModel.maxVoiceRetries = undefined;
        $scope.viewModel.wrongBlockTimeFormat = false;
        $scope.viewModel.hasAR3ReminderPermission = false;
        $scope.viewModel.isGroupWindowOrBlocktimeChanged = false;
        $scope.viewModel.fetchState = {
            buttonLabel: "Refresh",
            busy: false
        };
        $scope.subscription = new Subscription();
        // Map accountService to scope
        $scope.accountService = accountService;
        // As we might load several things, the indicator is a counter that tracks how many things we still need to load
        $scope.viewModel.loadingIndicatorOld = 0; // TODO: Remove when not used anymore
        $scope.viewModel.loadingIndicator = { 'state': false, 'refCount': 0 };
        $scope.viewModel.selectedPermissionGroup = null;
        $scope.viewModel.didCreatedPermissionGroup = -1;
        $scope.viewModel.isVets = false;
        $scope.viewModel.hasSuperAdminEditPermission = eventSharingService.hasPermission(['admin:user:permission:tmpfeature']);
        $scope.subscription.add(userSelectorsDowngraded.selectSelectedUserFeatures().subscribe(featureList => {
            accountService.featurePermissionList = [];
            accountService.featurePermissionList = angular.copy(featureList);
        }));
        $scope.subscription.add(userSelectorsDowngraded.selectFeatureChangedFlag().subscribe(hasChanged => {
            $scope.viewModel.changed = hasChanged;
        }));
        $scope.$on('$destroy', function () {
            $scope.subscription.unsubscribe();
        });
        $scope.setUserHasChangeFeatureFlag = function (flagValue) {
            storeDowngraded.dispatch(UserAction.setUserHasChangeFlag({ value: flagValue }));
        };
        // TODO: Change to use promise
        userProfile.getCountries(function () {
            logger.debug('countries.length=' + userProfile.countries.length);
            $scope.viewModel.countries = userProfile.countries;
        });
        /**
         * Request the backend for users matching the search pattern - typically used for type-ahead functionality.
         */
        $scope.searchUsersList = function (pattern) {
            $scope.viewModel.selectedUser = null; // None selected, so user details should be hidden
            $scope.viewModel.detailsVisible = false;
            return accountService.searchUser(pattern, $scope.viewModel.loadingIndicator)
                .then(function (users) {
                return $scope.viewModel.usersList = users;
            });
        };
        $scope.usernameChanged = function (userForm) {
            $scope.changed();
            $scope.checkIfUserExist(userForm.usernameInput);
        };
        $scope.checkIfUserExist = function (usernameInput) {
            if ($scope.viewModel.selectedUserInfo.userName === '') {
                return false;
            }
            accountService.checkIfUserExist($scope.viewModel.selectedUserInfo.userName, $scope.viewModel.loadingIndicator)
                .then(function (exist) {
                $scope.viewModel.userExist = exist;
                if (usernameInput !== undefined) {
                    usernameInput.$setValidity("nameExists", !exist); // We define a validity called nameExists
                }
                logger.debug('User (' + $scope.viewModel.selectedUserInfo.userName + ') exist? ' + exist);
            });
        };
        /**
         * The user's userPermission each has the same permissionGroupId so we'll just us the first item to find the group.
         */
        $scope.getFirstPermissionGroup = function (user) {
            if (user.hasOwnProperty('userPermissions') && user.userPermissions.length > 0) {
                // For some reason this crashes if setting $scope.viewModel.selectedUserInfo.permissionGroupId directly!!?
                var userInfo = Object.assign({}, $scope.viewModel.selectedUserInfo);
                userInfo.permissionGroupId = user.userPermissions[0].permissionGroupId;
                // $scope.viewModel.selectedUserInfo.permissionGroupId = id; // user.userPermissions[0].permissionGroupId;
                $scope.viewModel.selectedUserInfo = userInfo;
                $scope.viewModel.hasPreviousTwoWayPermission = $scope.hasTwoWayPermission(user.userPermissions);
                var groupIdx = accountService.getPermissionGroupIndex($scope.viewModel.selectedUserInfo.permissionGroupId);
                // For some reason it crashes if returning the group to set it by the caller!!?
                $scope.viewModel.selectedUserInfo.permissionGroup = accountService.permissionGroups[groupIdx];
                $scope.viewModel.selectedUserInfo.permissionGroupFromDB = $scope.viewModel.selectedUserInfo.permissionGroup;
            }
        };
        /**
         * This will check permissions for user currently selected and/or edited.
         * This is different from accountService.hasUserPermission() that will check permissions for logged in user
         */
        $scope.selectedUserHasPermission = function (permission) {
            if ($scope.viewModel.selectedUserInfo === undefined ||
                $scope.viewModel.selectedUserInfo === null) {
                // Initially, no permissions have been loaded or user has not even been initialized
                return false;
            }
            return accountService.hasPermission($scope.viewModel.selectedUserInfo, permission);
        };
        $scope.viewModel.loadingIndicator4 = { 'state': false, 'refCount': 0 };
        $scope.getkeys = function (event) {
            var keyCodeChar = event.key;
            if (!keyCodeChar.match(new RegExp('^[A-Za-z0-9]+$', 'i'))) {
                event.preventDefault();
                console.log('regex matched');
                return false;
            }
        };
        /**
         * This is used both for adding new user and saving changes to existing
         */
        $scope.saveUser = function () {
            if ($scope.viewModel.selectedUserInfo == null && $scope.viewModel.newMode === false) { // NOTE: Coercion intended
                $scope.viewModel.newMode = true;
                return;
            }
            var pattern = /\s/g;
            // Check for white space
            var hasWhitespaces = pattern.test($scope.viewModel.selectedUserInfo.userName);
            if (hasWhitespaces) {
                dialogs.error('Error', 'Username including whitespaces is not allowed');
                return;
            }
            if ($scope.viewModel.isBlockTimeOrProximityChanged) {
                dialogs.notify('Alert', 'You are making changes in proximity or blocktimes that will impact ALL future appointments.');
            }
            if ($scope.viewModel.isGroupWindowOrBlocktimeChanged) {
                dialogs.notify('Alert', 'You are making changes in proximity or blocktimes. Reminders already scheduled will not be affected unless doing factory reset and resync.');
            }
            if (angular.isDefined($scope.viewModel.selectedUserInfo) &&
                angular.isDefined($scope.viewModel.selectedUserInfo.userPassword) &&
                $scope.viewModel.selectedUserInfo.userPassword.toUpperCase().indexOf("STOP") !== -1 &&
                $scope.viewModel.selectedUserInfo.userStatus !== 'Stopped' &&
                $scope.viewModel.selectedUserInfo.userStatus !== 'Cancelled') {
                var stopDialog = dialogs.confirm('Confirm', 'The password contains "STOP". Is this an intentional part of the password? <br/><br/>If not, click "No" to cancel saving and set user status to <strong>"Cancelled"</strong> or <strong>"Stopped"</strong>.');
                stopDialog.result.then(function () {
                    // Yes - intentional, proceed to next check
                    $scope.checkPasswordChange();
                }, function () {
                    // No - note about stopping, cancel saving and change status
                    $scope.viewModel.selectedUserInfo.userStatus = 'Cancelled';
                    $scope.changed();
                });
            }
            else {
                $scope.checkPasswordChange();
            }
        };
        $scope.checkPasswordChange = function () {
            if (angular.isDefined($scope.viewModel.selectedUserInfo) &&
                angular.isDefined($scope.viewModel.selectedUserInfoBackup) &&
                angular.isDefined($scope.viewModel.selectedUserInfo.userId) &&
                $scope.viewModel.selectedUserInfo.userPassword !== $scope.viewModel.selectedUserInfoBackup.userPassword) {
                var dialog = dialogs.confirm('Confirm', 'Changing the Password will impact customer usage and can create increased support! Are you sure?');
                dialog.result.then(function (button) {
                    // Yes -store the new value so next "undo" will revert to this
                    $scope.viewModel.selectedUserInfoBackup.userPassword = $scope.viewModel.selectedUserInfo.userPassword;
                    $scope.confirmSaveUser();
                }, function (button) {
                });
            }
            else {
                $scope.confirmSaveUser();
            }
        };
        $scope.confirmSaveUser = function () {
            if (!angular.isDefined($scope.viewModel.selectedUserInfo.userTimeZone)) {
                $scope.viewModel.selectedUserInfo.userTimeZone = $scope.viewModel.selectedUserInfo.selectedUserTimeZone.value;
            }
            $scope.viewModel.isBlockTimeOrProximityChanged = false;
            $scope.viewModel.selectedUserInfo.permissionGroupId = $scope.viewModel.selectedUserInfo.permissionGroup.permissionGroupId;
            if ($scope.viewModel.selectedUserInfo.userPassword === undefined)
                $scope.viewModel.selectedUserInfo.userPassword = "";
            $scope.viewModel.selectedUserInfo.intervalStart = accountService.dateToInterval($scope.viewModel.intervalStartDate, "08:00");
            $scope.viewModel.selectedUserInfo.intervalStop = accountService.dateToInterval($scope.viewModel.intervalStopDate, "20:00");
            if (angular.isDefined($scope.viewModel.maxVoiceRetries)) {
                console.group('Max Voice Retries');
                var userCustomFields = $scope.viewModel.selectedUserInfo.userCustomFields;
                console.log("userCustomFields: ", userCustomFields);
                $scope.viewModel.selectedUserInfo.userCustomFields = Object.assign(Object.assign({}, userCustomFields), { "maxVoiceRetries": $scope.viewModel.maxVoiceRetries });
                console.log("userCustomFields updated: ", Object.assign(Object.assign({}, userCustomFields), { "maxVoiceRetries": $scope.viewModel.maxVoiceRetries }));
                console.groupEnd();
            }
            // when new user the userCustomFields is getting saved only in case of update its
            //throwing error Object appointmentProximity is not accessible
            if ($scope.viewModel.newMode) {
                if ($scope.viewModel.blockTimes !== undefined
                    && $scope.viewModel.selectedUserInfo.userCustomFields !== undefined
                    && $scope.viewModel.selectedUserInfo.userCustomFields !== null) {
                    $scope.viewModel.selectedUserInfo.userCustomFields.blockTimes = JSON.parse($scope.viewModel.blockTimes);
                }
                if ($scope.viewModel.appointmentProximity !== undefined
                    && $scope.viewModel.selectedUserInfo.userCustomFields !== undefined
                    && $scope.viewModel.selectedUserInfo.userCustomFields !== null) {
                    $scope.viewModel.selectedUserInfo.userCustomFields.appointmentProximity = $scope.viewModel.appointmentProximity;
                }
            }
            else {
                var account = {};
                var updateAccount = false;
                if ($scope.viewModel.blockTimes !== undefined &&
                    $scope.viewModel.selectedUserInfo.userCustomFields !== undefined &&
                    $scope.viewModel.selectedUserInfo.userCustomFields !== null &&
                    $scope.viewModel.selectedUserInfo.userCustomFields.blockTimes !== $scope.viewModel.blockTimes &&
                    $scope.viewModel.blockTimes.length > 0) {
                    account.blockTimes = JSON.parse($scope.viewModel.blockTimes);
                    updateAccount = true;
                }
                if ($scope.viewModel.appointmentProximity !== undefined &&
                    $scope.viewModel.selectedUserInfo.userCustomFields !== undefined &&
                    $scope.viewModel.selectedUserInfo.userCustomFields !== null &&
                    $scope.viewModel.selectedUserInfo.userCustomFields.appointmentProximity !== $scope.viewModel.appointmentProximity) {
                    account.appointmentProximity = $scope.viewModel.appointmentProximity;
                    updateAccount = true;
                }
                if (updateAccount) {
                    $scope.viewModel.selectedUserInfo.account = account;
                }
            }
            $scope.viewModel.saving = true;
            logger.debug('Saving user...');
            return accountService.saveUser($scope.viewModel.selectedUserInfo, $scope.viewModel.loadingIndicator)
                .then(function (response) {
                $scope.viewModel.selectedUserInfo.userId = response.user.userId;
                logger.debug('User saved with userId: ' + response.user.userId);
                if ($scope.selectedUserHasPermission('autoremind3')) {
                    // In case a user only created in Accounts (e.g. Reseller) is changed to e.g. Autoremind 2+3 user then
                    // it will also be created in Autoremind on save and switching userId to the one created by Autoremind
                    // The following will find the old settings, if any, and update with values from Accounts including new userId
                    // or if no settings created it will be created (in 'pause' mode)
                    accountService.updateAccountSettings($scope.viewModel.selectedUserInfo.userId, $scope.viewModel.loadingIndicator)
                        .then(function () {
                        $scope.navigateToDeviceSettings(response.user.userId);
                    }, function () {
                        // In case of errors we need to reactivate the save button
                        $scope.viewModel.saving = false;
                    });
                    // TODO: Create centralService to handle accountsetting (move from accountService)
                    // TODO: Inform user the change of userId and that templates stored by the old ID must be moved (both files and ref in database)
                }
                else {
                    $scope.navigateToDeviceSettings(response.user.userId);
                }
                $scope.viewModel.wrongBlockTimeFormat = false;
                // TODO: Find a way to detect changing away from autoremind2 permission and warn about notifications already scheduled?
                //$scope.viewModel.selectedUserInfo.userModifiedInt = response.user.userModifiedInt;
            }, function (errorResponse) {
                // In case of errors we need to reactivate the save button
                $scope.viewModel.saving = false;
                if (errorResponse.status === 409) {
                    // NOTE 2016-06-27: Optimistic locking has been disabled in AccountServlet
                    var dialog = dialogs.confirm('Confirm', 'Saving rejected because the data has been modified since. Do you wish to load latest data?');
                    dialog.result.then(function (button) {
                        // Yes - reload page to get latest data
                        $route.reload();
                    });
                }
            });
            // TODO: May fail - perhaps due to optimistic locking - should we load latest user and update UI (in case updated by other user)
        };
        $scope.deleteUser = function () {
            // TODO: button should only be enabled if userId is not null
            if ($scope.viewModel.selectedUserInfo.userId) {
                var message = 'Do you really want to delete user ' + $scope.viewModel.selectedUserInfo.userName + '(ID:' + $scope.viewModel.selectedUserInfo.userId + ') ?';
                var dialog = dialogs.confirm('Confirm', message);
                dialog.result.then(function (button) {
                    // Yes
                    accountService.deleteUser($scope.viewModel.selectedUserInfo.userId, $scope.viewModel.loadingIndicator)
                        .then(function (response) {
                        $scope.viewModel.newMode = true;
                        $scope.viewModel.updateMode = false;
                        $scope.viewModel.selectedUserInfo = null;
                        if ($location.$$search.userid) {
                            // Delete userid from url
                            delete $location.$$search.userid;
                            $location.$$compose();
                        }
                    });
                });
            }
        };
        /**
         * Output displayed by the type-ahead patient search field
         */
        $scope.userFormatInput = function (model) {
            if (model === null || !angular.isDefined(model))
                return '';
            return model.name;
        };
        $scope.setupMccCountry = function (userInfo) {
            if (userInfo.mcc) {
                // Ensure that the dropdown in the view is selecting correctly
                $scope.viewModel.selectedUserInfo.mcc = "" + userInfo.mcc;
                logger.debug("MCC in userInfo: " + userInfo.mcc);
                if (!userInfo.userCountry || userInfo.userCountry.length !== 2) {
                    var country = $scope.findCountry('mcc', userInfo);
                    // Setting user ISO should update the dropdown in the view
                    userInfo.userCountry = country.iso;
                    $scope.viewModel.selectedUserInfo.userCountry = userInfo.userCountry;
                    if (userInfo.countryPhonePrefix === undefined || userInfo.countryPhonePrefix === '') {
                        userInfo.countryPhonePrefix = country.area;
                    }
                }
            }
            else if (userInfo.userCountry) {
                // In case no mcc is set (user is not Autoremind2 user) we need to find mcc to make selection in dropdown in view
                logger.debug("Country in userInfo: " + userInfo.userCountry);
                if (userInfo.userCountry.length !== 2) {
                    if (userInfo.userCountry.length === 3) {
                        userInfo.mcc = userInfo.userCountry;
                        $scope.viewModel.selectedUserInfo.mcc = "" + userInfo.mcc;
                        var country = $scope.findCountry('mcc', userInfo);
                        userInfo.userCountry = "" + country.iso;
                        $scope.viewModel.selectedUserInfo.userCountry = userInfo.userCountry;
                    }
                    else if (userInfo.userCountry.length === 0) {
                        userInfo.mcc = '310'; //set to default US
                        $scope.viewModel.selectedUserInfo.mcc = "" + userInfo.mcc;
                        var country = $scope.findCountry('mcc', userInfo);
                        userInfo.userCountry = "" + country.iso;
                        $scope.viewModel.selectedUserInfo.userCountry = userInfo.userCountry;
                    }
                    else {
                        var country = $scope.findCountry('country', userInfo);
                        userInfo.mcc = country.mcc;
                        userInfo.userCountry = "" + country.iso;
                        $scope.viewModel.selectedUserInfo.mcc = "" + userInfo.mcc;
                        $scope.viewModel.selectedUserInfo.userCountry = userInfo.userCountry;
                        logger.debug("MCC now : " + userInfo.mcc);
                        if (userInfo.countryPhonePrefix === undefined || userInfo.countryPhonePrefix === '') {
                            userInfo.countryPhonePrefix = country.area;
                        }
                    }
                }
                else {
                    var country = $scope.findCountry('iso', userInfo);
                    userInfo.mcc = country.mcc;
                    $scope.viewModel.selectedUserInfo.mcc = "" + userInfo.mcc;
                    userInfo.userCountry = "" + country.iso;
                    $scope.viewModel.selectedUserInfo.userCountry = userInfo.userCountry;
                    logger.debug("MCC now : " + userInfo.mcc);
                    if (userInfo.countryPhonePrefix === undefined || userInfo.countryPhonePrefix === '') {
                        userInfo.countryPhonePrefix = country.area;
                    }
                }
            }
            else {
                if ($scope.selectedUserHasPermission('autoremind2')) {
                    logger.error("Missing MCC in userInfo: " + userInfo);
                }
            }
        };
        $scope.findCountry = function (condition, userInfo) {
            var selectCountry;
            for (var index in $scope.viewModel.countries) {
                var country = $scope.viewModel.countries[index];
                if (condition === 'iso') {
                    if (country.iso === userInfo.userCountry) {
                        selectCountry = country;
                        break;
                    }
                }
                if (condition === 'country') {
                    if (country.country === userInfo.userCountry) {
                        selectCountry = country;
                        break;
                    }
                }
                if (condition === 'mcc') {
                    if (country.mcc === userInfo.mcc) {
                        selectCountry = country;
                        break;
                    }
                }
            }
            return selectCountry;
        };
        $scope.setupDefaults = function (userInfoOriginal) {
            var userInfo = angular.copy(userInfoOriginal);
            if (userInfo === undefined) {
                return;
            }
            if ($scope.viewModel.newMode) {
                userInfo.mcc = {};
                userInfo.mcc = '310'; // Default to USA
                userInfo.userCountry = 'US';
            }
            $scope.setupMccCountry(userInfo);
            if (userInfo.userType === undefined) {
                userInfo.userType = accountService.userTypes[0];
            }
            if (userInfo.userStatus === undefined) {
                userInfo.userStatus = accountService.userStatuses[0];
            }
            // Initialize custom fields if not present as an object
            if (userInfo.userCustomFields === undefined) {
                userInfo.userCustomFields = {};
            }
            if (userInfo.countryPhonePrefix === undefined || userInfo.countryPhonePrefix === '') {
                userInfo.countryPhonePrefix = "1"; // Default because country is default USA
            }
        };
        /**
         * User is selected in the type-ahead list
         *
         * TODO: generalize so we can use it after add/save user
         * TODO: send message to some downgraded service to modify, say, adminUserState.userId
         * Should we update selectedUser directly or through a watcher?
         */
        $scope.getSelectedUserData = function () {
            if ($scope.viewModel.selectedUser === null) {
                return;
            }
            if (!$scope.viewModel.selectedUser.legacyOnly) {
                // Set new ID in URL to load page again for new user
                $location.search('userid', $scope.viewModel.selectedUser.userId);
            }
            else {
                dialogs.error('Error', 'Selected user (' + $scope.viewModel.selectedUser.name + ') only exist in legacy Autoremind2.');
            }
        };
        $scope.loadUser = function (userId, loadingIndicator) {
            $scope.viewModel.selectedUserInfo = {};
            accountService.getUser(userId, undefined, loadingIndicator)
                .then(function (user) {
                $scope.viewModel.updateToAutoremind3User = false;
                for (var i = 0; i < user.userPermissions.length; i++) {
                    if (user.userPermissions[i].permissionKey === 'resource:pets') {
                        $scope.viewModel.isVets = true;
                        // $translate.use('en_vets');
                        break;
                    }
                    if (user.userPermissions[i].permissionKey === 'communication:trackable:item') {
                        $scope.viewModel.trackableItems = true;
                        // $translate.use('en_vets');
                        break;
                    }
                }
                if (user.notInAccounts) {
                    // This will ensure tabs are hidden if user not valid
                    $scope.userId = 0;
                    $scope.viewModel.userId = 0;
                    dialogs.notify('Caution', 'Selected user (' + user.userName + ') only exist in legacy Autoremind. Either the user is no longer used or it is a partner.');
                }
                else {
                    $scope.viewModel.changed = false;
                    $scope.viewModel.updateMode = true;
                    $scope.viewModel.newMode = false;
                    // Make a mutable object allowing to add permissionGroup if it has none (e.g. if created in BackOffice)
                    $scope.viewModel.selectedUserInfo = angular.copy(user);
                    if (!Object.prototype.hasOwnProperty.call($scope.viewModel.selectedUserInfo, 'permissionGroup')) {
                        $scope.viewModel.selectedUserInfo.permissionGroup = null;
                    }
                    if (user.userCustomFields !== null && angular.isDefined(user.userCustomFields.blockTimes)) {
                        $scope.viewModel.blockTimes = JSON.stringify(user.userCustomFields.blockTimes);
                    }
                    if (user.userCustomFields !== null && angular.isDefined(user.userCustomFields.appointmentProximity)) {
                        $scope.viewModel.appointmentProximity = user.userCustomFields.appointmentProximity;
                    }
                    //Load max voice retries field
                    if (angular.isDefined(user.userCustomFields) && user.userCustomFields !== null && angular.isDefined(user.userCustomFields.maxVoiceRetries)) {
                        $scope.viewModel.maxVoiceRetries = +user.userCustomFields.maxVoiceRetries;
                    }
                    if (angular.isDefined(user.userCustomFields) &&
                        user.userCustomFields !== null &&
                        angular.isUndefined(user.userCustomFields.maxVoiceRetries &&
                            angular.isDefined(user.maxReschedule))) {
                        $scope.viewModel.maxVoiceRetries = +user.maxReschedule;
                    }
                    accountService.selectedUser = user;
                    accountService.setSelectedUser(user);
                    $location.search('userid', $scope.viewModel.selectedUserInfo.userId);
                    // Fetch group and update view with correct group
                    //$scope.viewModel.selectedUserInfo.permissionGroup = $scope.getFirstPermissionGroup(user);
                    $scope.getFirstPermissionGroup(user);
                    accountService.getAccountSettings($scope.viewModel.selectedUserInfo.userId, $scope.viewModel.loadingIndicator)
                        .then(function (settings) {
                        $scope.viewModel.selectedUserInfo.schedulerState = settings.schedulerState;
                        accountService.accountSettings.accountScheduler = settings.accountScheduler;
                        //check if the accountScheduler is empty for new user, if yes, set it to ar3active
                        if (accountService.accountSettings.accountScheduler === undefined || accountService.accountSettings.accountScheduler === '') {
                            if ($scope.isOnlyAutoremind3User(user.userPermissions)) {
                                accountService.accountSettings.accountScheduler = 'ar3active';
                            }
                            else {
                                if (accountService.accountSettings.accountScheduler === '') {
                                    accountService.accountSettings.accountScheduler = settings.schedulerState !== 'pause' ? settings.schedulerState : 'active';
                                }
                            }
                            $scope.viewModel.selectedUserInfo.accountScheduler = accountService.accountSettings.accountScheduler;
                        }
                        $scope.isOnlyAutoremind3User(user.userPermissions);
                        $scope.viewModel.selectedUserInfo.displaySchedulerState = settings.schedulerState === 'pause' && accountService.schedulerState.indexOf(accountService.accountSettings.accountScheduler) !== -1;
                    });
                    // Set default especially in case user is changed to autoremind2 user
                    $scope.setupDefaults(user);
                    // find and set the timezone, if already mapped before
                    if ($scope.viewModel.selectedUserInfo !== undefined && $scope.viewModel.selectedUserInfo.userTimeZone !== undefined) {
                        $scope.viewModel.selectedUserInfo.selectedUserTimeZone = accountService.timezones.find(timezone => timezone.value === $scope.viewModel.selectedUserInfo.userTimeZone);
                    }
                    // Create copy to use for checking for specific changes (and can also be used for undo)
                    $scope.viewModel.selectedUserInfoBackup = angular.copy($scope.viewModel.selectedUserInfo);
                    return user;
                }
            }).then(function (selectedUser) {
                if (selectedUser !== undefined && selectedUser.userName !== '') {
                    if (!$scope.isOnlyAutoremind3User(selectedUser.userPermissions)) {
                        /* Obsolete - will fail because AR2 is shut down
                        $scope.getSelectedUserAutoremin2Permissions(selectedUser.userName).then(function (permissions) {
                             $scope.viewModel.selectedUserInfo.selectedUserAutoremind2Permissions = permissions;
                         });
                         */
                    }
                }
            });
        };
        $scope.portalLogin = function (option) {
            var protocol = $location.protocol();
            var port = ':' + $location.port();
            if (port === ':80')
                port = '';
            var host = 'localhost';
            var url;
            switch (option) {
                case 'production':
                    host = 'backend.autoremind.us';
                    port = '';
                    break;
                case 'frontendalpha':
                    host = 'frontdesk.autoremind.us';
                    port = '';
                    break;
                case 'beta':
                    host = 'backendbeta.autoremind.us';
                    port = '';
                    break;
                case 'alpha':
                    host = 'backendalpha.autoremind.us';
                    port = '';
                    break;
                case 'dev':
                    //host = 'backenddevapp1.int.autoremind.us';
                    host = 'backenddev.autoremind.us';
                    port = '';
                    break;
                case 'frontenddev':
                    host = 'frontenddev.autoremind.us';
                    port = '';
                    break;
            }
            if (option !== 'frontendalpha' && option !== 'frontenddev') {
                url = protocol + '://' + host + port + '?username=' + $scope.viewModel.selectedUserInfo.userName +
                    '&password=' + $scope.viewModel.selectedUserInfo.userPassword +
                    '&page=direct&admin=true';
            }
            else {
                url = 'https://' + host + port + '/dashboard?delegatedAccount=' + $scope.viewModel.selectedUserInfo.userName;
            }
            logger.debug('url=' + url);
            $window.open(url, '_blank');
        };
        $scope.initUsers = function () {
            accountService.getPermissions($scope.viewModel.loadingIndicator)
                .then(function (permissions) {
                return $scope.getPermissionGroups();
            })
                .then(function () {
                return accountService.getTimezones($scope.viewModel.loadingIndicator);
            })
                .then(function (timezones) {
                $scope.viewModel.userId = $location.search()['userid'] || accountService.selectedUserId;
                if (angular.isDefined($scope.viewModel.userId) && $scope.viewModel.userId && $scope.viewModel.userId !== '') {
                    $scope.loadUser($scope.viewModel.userId, $scope.viewModel.loadingIndicator);
                }
                else {
                    // Set defaults for new user
                    $scope.setupDefaults($scope.viewModel.selectedUserInfo);
                }
            });
        };
        $scope.wipeAccountAppointments = function (userId, userName) {
            if ($scope.accountService.accountSettings.schedulerState !== 'pause') {
                dialogs.notify($filter('i18n')('_dialogHeaderWarning_'), $filter('i18n')('_dialogUserAdminShouldPause_'));
                return;
            }
            var resourcesToWipe = { appointments: true };
            var dialog = dialogs.confirm($filter('i18n')('_dialogHeaderConfirm_'), 'Are you sure you want to wipe all appointments for this account (' + userName + ')?');
            dialog.result.then(function (button) {
                // Yes
                $scope.accountService.wipeAccount(userId, userName, resourcesToWipe, $scope.viewModel.loadingIndicator);
            });
        };
        $scope.openCentralDataDialog = function (userId, userName, isVets, trackableItems) {
            if ($scope.accountService.accountSettings.schedulerState !== 'pause') {
                dialogs.notify($filter('i18n')('_dialogHeaderWarning_'), $filter('i18n')('_dialogUserAdminShouldPause_'));
                return;
            }
            console.log('In autoremind.users.ScreenController.openCentralDataDialog()');
            var dialog = dialogs.create('app/admin/users/central-data.dialog.html', 'autoremind.users.CentralDataDialogController', { userId: userId, userName: userName, isVets: isVets, trackableItems: trackableItems }, { key: false, back: 'static', backdrop: 'static' });
            dialog.result
                .then(function () {
            }, function () {
            });
        };
        $scope.schedulerKeyChange = function () {
            $scope.viewModel.selectedUserInfo.accountScheduler = accountService.accountSettings.accountScheduler;
            //  $scope.changed();
        };
        $scope.pauseScheduler = function (userId) {
            accountService.accountSettings.accountScheduler = accountService.accountSettings.schedulerState;
            $scope.viewModel.selectedUserInfo.displaySchedulerState = accountService.schedulerState.indexOf(accountService.accountSettings.accountScheduler) !== -1;
            accountService.accountSettings.schedulerState = 'pause';
            $scope.viewModel.selectedUserInfo.schedulerState = accountService.accountSettings.schedulerState;
            accountService.setAccountSchedulerState(userId, accountService.accountSettings.schedulerState);
        };
        $scope.resumeScheduler = function (userId) {
            $scope.viewModel.selectedUserInfo.displaySchedulerState = false;
            accountService.accountSettings.schedulerState = accountService.accountSettings.accountScheduler;
            $scope.viewModel.selectedUserInfo.schedulerState = accountService.accountSettings.schedulerState;
            accountService.setAccountSchedulerState(userId, accountService.accountSettings.schedulerState);
        };
        // ------- Permissions methods and data model ------------
        // When permission group data is changed, don't spam the server.
        $scope.viewModel.updatePermissionGroupTimer = null;
        $scope.viewModel.selectedPermissions = [];
        $scope.viewModel.editPermissionNames = [];
        $scope.viewModel.editPermissionDescriptions = [];
        $scope.initPermissions = function () {
            // Get permissions first and then groups that will link to permissions
            accountService.getPermissions($scope.viewModel.loadingIndicator)
                .then(function () {
                $scope.getPermissionGroups()
                    .then(function () {
                    // The following seems to be used by permissions.html though it looks wrong and unclear why first permission is added to all
                    if (accountService.permissions !== undefined) {
                        var firstPermission = accountService.permissions[0];
                        for (var i = 0; i < accountService.permissionGroups.length; i++) {
                            var group = accountService.permissionGroups[i].permissionGroupId;
                            $scope.viewModel.selectedPermissions[group] = firstPermission;
                            $scope.resetMetaEdit(group);
                        }
                    }
                });
            });
        };
        $scope.showFields = function () {
            return $scope.viewModel.updateMode || $scope.viewModel.newMode;
        };
        $scope.getModuleType = function (selectedUserInfo) {
            if (!selectedUserInfo.hostedUsers || selectedUserInfo.hostedUsers.length === 0) {
                if (selectedUserInfo.moduleType) {
                    return selectedUserInfo.moduleType;
                }
                else {
                    return '';
                }
            }
            var moduleType = selectedUserInfo.hostedUsers[0].moduleType;
            for (var i in selectedUserInfo.hostedUsers) {
                if (selectedUserInfo.hostedUsers[i].moduleType !== moduleType) {
                    return 'Host';
                }
            }
            selectedUserInfo.isModuleTypeDefined = true;
            return 'Host (' + moduleType + ')';
        };
        $scope.timezoneRequired = function () {
            return true;
            /*return $scope.viewModel.selectedUserInfo &&
            $scope.viewModel.selectedUserInfo.permissionGroup*/ /* &&
$scope.selectedUserHasPermission('autoremind2');*/
        };
        $scope.changedCountry = function () {
            var mcc = $scope.viewModel.selectedUserInfo.mcc;
            for (var index in $scope.viewModel.countries) {
                var country = $scope.viewModel.countries[index];
                if (country.mcc === mcc) {
                    //$scope.viewModel.selectedUserInfo.userCountry = country.country;
                    $scope.viewModel.selectedUserInfo.userCountry = country.iso;
                    $scope.viewModel.selectedUserInfo.countryPhonePrefix = country.area;
                    break;
                }
            }
            $scope.changed();
        };
        $scope.groupOrBlocktimesChanged = function () {
            $scope.viewModel.isGroupWindowOrBlocktimeChanged = true;
            $scope.changed();
        };
        $scope.changed = function () {
            $scope.viewModel.changed = true;
        };
        $scope.blockTimeOrProximityChanged = function (openBlockTime) {
            var blockedTime = $scope.setDefaultBlockTime();
            var appointmentProximity = $scope.setDefaultAppointmentProximity();
            if (!openBlockTime) {
                $scope.viewModel.blockTimes = JSON.stringify(blockedTime);
                $scope.viewModel.appointmentProximity = appointmentProximity;
            }
            else {
                if (!$scope.viewModel.isBlockTimeOrProximityChanged) {
                    var dialog = dialogs.confirm('Confirm', 'You are making changes in proximity or blocktimes that will impact ALL future appointments. The change will not have effect before saving. Are you sure you want to continue?');
                    dialog.result.then(function (button) {
                        // Yes - store the new value so next "undo" will revert to this
                        $scope.blockTimeAndProximity(blockedTime, appointmentProximity);
                    }, function (button) {
                        // No - revert to blockTimes before
                        $scope.viewModel.blockTimes = JSON.stringify($scope.viewModel.selectedUserInfo.userCustomFields.blockTimes);
                        $scope.viewModel.appointmentProximity = $scope.viewModel.selectedUserInfo.userCustomFields.appointmentProximity;
                    });
                }
                else {
                    $scope.blockTimeAndProximity(blockedTime, appointmentProximity);
                }
            }
        };
        $scope.setDefaultBlockTime = function () {
            var blockedTime = $scope.viewModel.blockTimes;
            if (blockedTime === undefined || blockedTime.length === 0) {
                blockedTime = [{ 'stop': 1200, 'start': 480 }];
            }
            else {
                blockedTime = JSON.parse(blockedTime);
            }
            return blockedTime;
        };
        $scope.setDefaultAppointmentProximity = function () {
            return $scope.viewModel.appointmentProximity === undefined ? 0 : $scope.viewModel.appointmentProximity;
        };
        $scope.blockTimeAndProximity = function (blockedTime, appointmentProximity) {
            storeDowngraded.dispatch(BlockTimesProximityActions.openBlockTimesProximityDialogFromAngularJS({ blockTimes: blockedTime, proximity: appointmentProximity }));
            var subscribe = blockTimesProximitySelectorsDowngraded.selectGetBlockTimes()
                .subscribe(function (response) {
                if (response !== []) {
                    $scope.viewModel.isBlockTimeOrProximityChanged = true;
                    $scope.viewModel.blockTimes = JSON.stringify(response);
                }
            });
            var subscribe2 = blockTimesProximitySelectorsDowngraded.selectGetProximity()
                .subscribe(function (response) {
                if (response !== -1) {
                    $scope.viewModel.appointmentProximity = response;
                }
            });
            var subscribe3 = blockTimesProximitySelectorsDowngraded.selectIsCancelled()
                .subscribe(function (response) {
                if (!response) {
                    $scope.changed();
                }
            });
        };
        $scope.applyPermissionGroupChange = function (permissionGroup, previousIsOnlyAutoremind3User) {
            // Yes - store the new value so next "undo" will revert to this
            if ($scope.viewModel.selectedUserInfoBackup !== undefined) {
                $scope.viewModel.selectedUserInfoBackup.permissionGroup = permissionGroup;
            }
            $scope.viewModel.updateToAutoremind3User = false;
            $scope.viewModel.hasAR3ReminderPermission = false;
            if (permissionGroup && $scope.isOnlyAutoremind3User(permissionGroup.permissions) && !previousIsOnlyAutoremind3User) {
                $scope.viewModel.updateToAutoremind3User = true;
            }
            $scope.setupDefaults($scope.viewModel.selectedUserInfo);
            $scope.blockTimeOrProximityChanged(false);
            if ($scope.viewModel.updateToAutoremind3User) {
                if (angular.isUndefined($scope.viewModel.selectedUserInfo.userCustomFields.maxVoiceRetries)) {
                    if (angular.isDefined($scope.viewModel.selectedUserInfo.maxReschedule)) {
                        $scope.viewModel.maxVoiceRetries = +$scope.viewModel.selectedUserInfo.maxReschedule;
                    }
                    else {
                        $scope.viewModel.maxVoiceRetries = 1;
                    }
                }
            }
            $scope.changed();
        };
        $scope.changeUserPermissionGroup = function (previousPermissionGroup) {
            if (previousPermissionGroup === undefined || $scope.viewModel.selectedUserInfo === undefined || $scope.viewModel.selectedUserInfo === null) {
                return;
            }
            if ($scope.viewModel.selectedUserInfo.userId !== undefined) {
                if ($scope.viewModel.selectedUserInfo.permissionGroupFromDB !== undefined && $scope.viewModel.selectedUserInfo.permissionGroupFromDB !== null) {
                    var message = 'You are about to change the permissions to access various systems and features and some require further settings. The change will not have effect before saving changes. Are you sure you want to change access?';
                    if ($scope.selectedUserHasPermission('reseller') && $scope.viewModel.selectedUserInfo.userType !== 'Reseller') {
                        message = 'You are about to change the permissions to access various systems and features and some require further settings. The change will not have effect before saving changes. Please remember to change user Type to Reseller. Are you sure you want to change access?';
                    }
                    var dialog = dialogs.confirm('Confirm', message);
                    dialog.result.then(function (button) {
                        var previousIsOnlyAutoremind3User = true;
                        if ($scope.viewModel.selectedUserInfo.permissionGroupFromDB && $scope.viewModel.selectedUserInfo.permissionGroupFromDB.permissions) {
                            previousIsOnlyAutoremind3User = $scope.isOnlyAutoremind3User($scope.viewModel.selectedUserInfo.permissionGroupFromDB.permissions);
                        }
                        $scope.applyPermissionGroupChange($scope.viewModel.selectedUserInfo.permissionGroup, previousIsOnlyAutoremind3User);
                    }, function (button) {
                        // No - revert to permission group selected before
                        $scope.viewModel.selectedUserInfo.permissionGroup = $scope.viewModel.selectedUserInfo.permissionGroupFromDB;
                    });
                }
                else {
                    // Except we only reach this for new accounts created in BackOffice so previousIsOnlyAutoremind3User = true
                    $scope.applyPermissionGroupChange($scope.viewModel.selectedUserInfo.permissionGroup, true);
                }
            }
            else {
                $scope.setupDefaults($scope.viewModel.selectedUserInfo);
            }
        };
        $scope.applyTimeZoneChange = function (selectedTimeZone) {
            $scope.viewModel.selectedUserInfo.userTimeZone = selectedTimeZone.value;
            if ($scope.viewModel.selectedUserInfoBackup !== undefined) {
                $scope.viewModel.selectedUserInfoBackup.userTimeZone = angular.copy($scope.viewModel.selectedUserInfo.userTimeZone);
                $scope.viewModel.selectedUserInfoBackup.selectedUserTimeZone = angular.copy(selectedTimeZone);
            }
            $scope.changed();
        };
        $scope.setUserTimeZone = function () {
            if ($scope.viewModel.selectedUserInfo == null) { // Coercion intended
                return;
            }
            if ($scope.viewModel.updateMode) {
                if ($scope.viewModel.selectedUserInfoBackup !== undefined && $scope.viewModel.selectedUserInfoBackup.userTimeZone !== undefined && $scope.viewModel.selectedUserInfoBackup.userTimeZone !== null) {
                    logger.debug('old value ' +
                        ' => new value ' + $scope.viewModel.selectedUserInfo.userTimeZone);
                    var dialog = dialogs.confirm('Confirm', 'Changing the Timezone will impact customer usage and can create increased support! Are you sure?');
                    dialog.result.then(function (button) {
                        $scope.applyTimeZoneChange($scope.viewModel.selectedUserInfo.selectedUserTimeZone);
                    }, function (button) {
                        // No - revert timezone
                        $scope.viewModel.selectedUserInfo.selectedUserTimeZone = accountService.timezones.find(timezone => timezone.value === $scope.viewModel.selectedUserInfoBackup.selectedUserTimeZone.value);
                    });
                }
                else {
                    $scope.applyTimeZoneChange($scope.viewModel.selectedUserInfo.selectedUserTimeZone);
                }
            }
        };
        $scope.setUserPassword = function () {
            if ($scope.viewModel.updateMode) {
                // This is called on blur so we need to check if any changes were made
                if ($scope.viewModel.selectedUserInfo.userPassword !== $scope.viewModel.selectedUserInfoBackup.userPassword) {
                    var dialog = dialogs.confirm('Confirm', 'Changing the Password will impact customer usage and can create increased support! Are you sure?');
                    dialog.result.then(function (button) {
                        // Yes -store the new value so next "undo" will revert to this
                        $scope.viewModel.selectedUserInfoBackup.userPassword = $scope.viewModel.selectedUserInfo.userPassword;
                        $scope.changed();
                    }, function (button) {
                        // No - revert password
                        $scope.viewModel.selectedUserInfo.userPassword = $scope.viewModel.selectedUserInfoBackup.userPassword;
                        $scope.viewModel.changed = false;
                    });
                }
            }
        };
        // TODO: Refactor to use save button to save settings
        $scope.resetMetaEdit = function (permissionGroupId) {
            // Note: currently we edit name and description at the same time
            var permissionGroupIndex = accountService.getPermissionGroupIndex(permissionGroupId);
            if (permissionGroupIndex < 0) {
                dialogs.error('Error', 'Selected permission group ' + permissionGroupId + ' not found for resetMetaEdit');
                return;
            }
            $scope.viewModel.editPermissionNames[accountService.permissionGroups[permissionGroupIndex].permissionGroupId] =
                {
                    editing: false,
                };
            $scope.viewModel.editPermissionDescriptions[accountService.permissionGroups[permissionGroupIndex].permissionGroupId] =
                {
                    editing: false,
                    editValue: accountService.permissionGroups[permissionGroupIndex].permissionGroupDescription
                };
        };
        // TODO: Refactor to use save button to save settings
        $scope.activateMetaEdit = function (permissionGroupId) {
            // Note: currently we edit name and description at the same time
            $scope.viewModel.editPermissionNames[permissionGroupId].editing = !$scope.viewModel.editPermissionNames[permissionGroupId].editing;
        };
        // TODO: Refactor to use save button to save settings
        $scope.saveMetaEdit = function (permissionGroupId) {
            // Note: currently we edit name and description at the same time
            // Overwrite the name and description with the edit-values
            var permissionGroupIndex = accountService.getPermissionGroupIndex(permissionGroupId);
            if (permissionGroupIndex < 0) {
                dialogs.error('Error', 'Selected permission group not found');
                return;
            }
            accountService.permissionGroups[permissionGroupIndex].permissionGroupName = $scope.viewModel.editPermissionNames[permissionGroupId].editValue;
            accountService.permissionGroups[permissionGroupIndex].permissionGroupDescription = $scope.viewModel.editPermissionDescriptions[permissionGroupId].editValue;
            $scope.resetMetaEdit(permissionGroupId);
        };
        // TODO: Refactor to use save button to save settings - add new unsaved with empty name and description
        $scope.addPermissionGroup = function () {
            var groupName = "New Permission Group";
            var groupDescription = "";
            accountService.addPermissionGroup(groupName, groupDescription, $scope.viewModel.loadingIndicator)
                .then(function (response) {
                $scope.viewModel.didCreatedPermissionGroup = parseInt(response.permissionGroupId);
                $scope.getPermissionGroups();
            });
        };
        // TODO: Refactor to use save button to save settings
        $scope.updatePermissionGroup = function () {
            if ($scope.viewModel.updatePermissionGroupTimer != null) {
                clearTimeout($scope.viewModel.updatePermissionGroupTimer);
            }
            $scope.viewModel.updatePermissionGroupTimer = setTimeout(function () {
                $scope.doUpdatePermissionGroup();
            }, 500);
        };
        // TODO: Refactor to just save only on pressing a save button
        $scope.doUpdatePermissionGroup = function () {
            if ($scope.viewModel.selectedPermissionGroup === null) {
                dialogs.error('Error', 'No permission group selected');
                return;
            }
            if ($scope.viewModel.loadingIndicator.state) {
                // wait until free
                $scope.viewModel.updatePermissionGroupTimer = setTimeout(function () {
                    $scope.doUpdatePermissionGroup();
                }, 100);
                return;
            }
            // TODO: Move modifiedInt to service (and rename to millis)
            accountService.updatePermissionGroup($scope.viewModel.selectedPermissionGroup, $scope.viewModel.loadingIndicator);
        };
        // TODO: Refactor to use save button to save settings and in stead set empty name on adding new unsaved group and notify user if name is used and only allow saving if unique name
        $scope.makePermissionGroupNameUnique = function (permissionGroup) {
            // Make sure this permission group has a unique name
            var groupName = permissionGroup.permissionGroupName;
            var cnt = 1;
            // TODO: Refactor to a while loop - restarting for loop is ugly! Or just wait until we refactor to use save button
            for (var i = 0; i < accountService.permissionGroups.length; i++) {
                if (accountService.permissionGroups[i].permissionGroupId !== permissionGroup.permissionGroupId) {
                    if (accountService.permissionGroups[i].permissionGroupName === groupName) {
                        groupName = permissionGroup.permissionGroupName + " (" + cnt + ")";
                        i = -1; // restart
                        cnt++;
                    }
                }
            }
            if (cnt > 1) {
                permissionGroup.permissionGroupName = name;
                $scope.updatePermissionGroup();
            }
        };
        // TODO: Refactor to use save button to save settings
        $scope.checkPermission = function (permissionIndex) {
            var permissionGroupId = $scope.viewModel.selectedPermissionGroup.permissionGroupId;
            var permissionId = accountService.permissions[permissionIndex].permissionId;
            accountService.addPermissionToGroupModel(permissionGroupId, permissionId);
            accountService.addPermissionToGroup(permissionGroupId, permissionId, $scope.viewModel.loadingIndicator);
        };
        // TODO: Refactor to use save button to save settings
        $scope.uncheckPermission = function (permissionIndex) {
            var permissionGroupId = $scope.viewModel.selectedPermissionGroup.permissionGroupId;
            var permissionId = accountService.permissions[permissionIndex].permissionId;
            accountService.removePermissionFromGroupModel(permissionGroupId, permissionId);
            accountService.removePermissionFromGroup(permissionGroupId, permissionId, $scope.viewModel.loadingIndicator);
        };
        // TODO: Refactor to use save button to save settings
        $scope.isPermissionInSelectedGroup = function (permissionIndex, permissionGroupId) {
            if (accountService.permissionGroups === undefined
                || $scope.viewModel.selectedPermissionGroup === null) {
                return false;
            }
            var permissionGroupIndex = accountService.getPermissionGroupIndex(permissionGroupId);
            var permissionId = accountService.permissions[permissionIndex].permissionId;
            return accountService.getPermissionIndexInGroup(permissionGroupIndex, permissionId) >= 0;
        };
        $scope.getPermissionGroups = function () {
            return accountService.getPermissionGroups($scope.viewModel.loadingIndicator)
                .then(function (permissionGroup) {
                // For every permission group add to list which permission is selected in select-tag
                // TODO: Create directive that will select first by default unless parameter specifies another index, remember selected before loading
                //TODO: Change to only select if no selected or selected no longer in list
                $scope.viewModel.selectedPermissionGroup = accountService.permissionGroups[0];
                if ($scope.viewModel.didCreatedPermissionGroup >= 0) {
                    var groupIdx = accountService.getPermissionGroupIndex($scope.viewModel.didCreatedPermissionGroup);
                    $scope.viewModel.didCreatedPermissionGroup = -1;
                    $scope.viewModel.selectedPermissionGroup = accountService.permissionGroups[groupIdx];
                    $scope.makePermissionGroupNameUnique($scope.viewModel.selectedPermissionGroup);
                }
            });
        };
        $scope.savePermission = function () {
            console.log('-------- Save Permission --------- ');
        };
        $scope.addPermission = function () {
            accountService.addPermission($scope.viewModel.permission.permissionKey, $scope.viewModel.permission.permissionName, $scope.viewModel.permission.permissionDescription, $scope.viewModel.loadingIndicator);
        };
        $scope.permissionChanged = function () {
            $scope.viewModel.permission.changed = true;
        };
        // ---------- End of stuff from permissions.controller
        $scope.viewModel.activeTabIndex = 0;
        $scope.viewModel.tabIndexes = {
            user: 0,
            centraldata: 1,
            revenueshare: 2,
            communication: 3,
            billingSettings: 4,
            devices: 5
        };
        $scope.viewModel.prevTabName = 'user';
        $scope.billingSettings = null;
        $scope.initForNewUser = function () {
            $scope.viewModel.newMode = true;
            $scope.viewModel.selectedUser = null;
            $scope.viewModel.selectedUserInfo = {};
            accountService.setSelectedUser(undefined);
            $scope.viewModel.blockTimes = JSON.stringify([{ 'start': 480, 'stop': 1200 }]);
            $scope.viewModel.maxVoiceRetries = 1;
        };
        if ($location.path() === '/admin/users/new') {
            accountService.setSelectedUser(undefined);
            accountService.selectedUser = undefined;
        }
        $scope.userId = $location.search()['userid'] || accountService.selectedUserId;
        // Adding condition when we delete user, not to add the userid as search param
        if (!$location.search()['userid'] && ($location.path() !== '/admin/users/new' && $location.path() !== '/admin/users/find/user')) {
            $location.search('userid', $scope.userId);
        }
        $scope.isUsersInitStarted = false;
        $scope.isTabChangeAccepted = false;
        $scope.beforeTabChange = function ($event, $selectedIndex) {
            if ($scope.viewModel.saving || $scope.viewModel.changed) {
                if ($scope.acceptedTabIndex !== undefined) {
                    $scope.isTabChangeAccepted = false;
                    return;
                }
                var dialog = dialogs.confirm('Confirm', 'You have unsaved changes that will be lost. Are you sure you want to leave this page?');
                dialog.result.then(function () {
                    // Yes
                    $scope.viewModel.activeTabIndex = $selectedIndex; // This will call selected=setRoute() for the new tab
                    $scope.isTabChangeAccepted = true;
                    // $location.$$parse(newUrl);
                    $scope.viewModel.saving = false;
                    $scope.viewModel.changed = false;
                    // $location.absUrl(newUrl);
                    $scope.setUserHasChangeFeatureFlag(false);
                }, function () {
                    // No - preventDefault already cancelled tab change
                    // $scope.viewModel.activeTabIndex = $scope.viewModel.tabIndexes[$scope.viewModel.prevTabName];
                    $scope.isTabChangeAccepted = false;
                });
                $event.preventDefault();
            }
        };
        $scope.setDeviceSettingsRoute = function (userId) {
            var tabName = 'devices';
            var newPath = '/admin/users/find/' + tabName;
            $scope.viewModel.activeTabIndex = $scope.viewModel.tabIndexes[tabName];
            $location.path(newPath, false).search('userid', userId);
        };
        $scope.setRoute = function (tabName) {
            if ($location.path().indexOf('/admin/users') !== -1) {
                if ($location.path() === '/admin/users/new') {
                    $scope.initForNewUser();
                    if (!$scope.isUsersInitStarted) {
                        $scope.isUsersInitStarted = true;
                        $scope.initUsers();
                    }
                    return;
                }
                if (!$scope.isUsersInitStarted) {
                    $scope.isUsersInitStarted = true;
                    // This service should be called only if tabName is user or if user is not set up
                    if (tabName === 'user' || $scope.viewModel.userId === 0) {
                        $scope.initUsers();
                    }
                }
                if (!angular.isDefined($scope.viewModel.tabIndexes[tabName])) {
                    tabName = 'user';
                }
                $scope.viewModel.activeTabIndex = $scope.viewModel.tabIndexes[tabName];
                // if (!$scope.viewModel.saving && !$scope.viewModel.changed) {
                //     $scope.viewModel.prevTabName = tabName;
                // }
                var newPath = '/admin/users/find/' + tabName;
                if ($location.path() !== newPath) {
                    $location.path(newPath, false);
                }
            }
            else {
                $scope.initPermissions();
            }
        };
        $scope.navigateToDeviceSettings = function (userId) {
            // TODO: Find a way to detect when changing away from autoremind3 permission and pause in Central - perhaps set a flag on the user
            $scope.viewModel.saving = false;
            $scope.viewModel.changed = false;
            var permissions = $scope.viewModel.selectedUserInfo.permissionGroup.permissions;
            // Check if user had two-way permission before updating
            if (!$scope.viewModel.hasPreviousTwoWayPermission && $scope.hasTwoWayPermission(permissions)) {
                var message = 'Device Settings for Two-way Texting needs to be set up. Do you want to set up now?';
                var dialog = dialogs.confirm('Confirm', message);
                dialog.result.then(function (button) {
                    if (button === 'yes') {
                        $scope.setDeviceSettingsRoute(userId);
                    }
                    else {
                        $location.path('/admin/users/find').search({ "userid": userId });
                    }
                });
            }
            else {
                // Load the saved user data (this only has effect when saving new where userid is set/changed in the url)
                $location.path('/admin/users/find').search({ "userid": userId });
            }
            // TODO: Only do this when saving new (to avoid clearing the screen and reload) - but ensure it still works for switching id
        };
        $scope.hasTwoWayPermission = function (permissions) {
            var twoWayPermission = false;
            for (var index in permissions) {
                if (permissions[index].permissionKey === 'twoway') {
                    twoWayPermission = true;
                    break;
                }
            }
            return twoWayPermission;
        };
        $scope.isOnlyAutoremind3User = function (permissions) {
            var isAR3ReminderUser = false;
            var isAutoremind3User = false;
            var isAutoremind2User = false;
            for (var index in permissions) {
                if (permissions[index].permissionKey === 'autoremind3:reminders') {
                    isAR3ReminderUser = true;
                    $scope.viewModel.hasAR3ReminderPermission = true;
                }
                if (permissions[index].permissionKey === 'autoremind3') {
                    isAutoremind3User = true;
                }
                if (permissions[index].permissionKey === 'autoremind2') {
                    isAutoremind2User = true;
                }
            }
            if (!isAutoremind2User) {
                // If created in BackOffice and not with old "autoremind3" permission then still treat as AR3 user
                return true;
            }
            return (isAR3ReminderUser || isAutoremind3User) && !isAutoremind2User;
        };
        $scope.setRoute($routeParams.tabname);
        $scope.openFeatureModal = function () {
            console.log('OPENING FEATURE DIALOG ...');
            storeDowngraded.dispatch(AdminUsersActions.openFeaturesModal());
        };
    }]);
angular.module('autoremind.users')
    .controller('autoremind.users.CentralDataDialogController', 
// Setup dependencies
['$scope', '$log', '$uibModalInstance', '$location', 'data', 'dialogs', 'accountService',
    function ($scope, $log, $uibModalInstance, $location, data, dialogs, accountService) {
        if (!angular.isDefined($scope.viewModel)) {
            $scope.viewModel = {};
        }
        var loadTime = 5;
        var loading = false;
        $scope.timeToDisable = loadTime;
        $scope.viewModel.data = (angular.isDefined(data)) ? data : '';
        $scope.userId = data.userId ? data.userId : '';
        $scope.userName = data.userName ? data.userName : '';
        $scope.isVets = data.isVets ? data.isVets : false;
        $scope.trackableItems = data.trackableItems ? data.trackableItems : false;
        $scope.viewModel.loadingIndicator = { 'state': false, 'refCount': 0 };
        $scope.viewModel.toWipe = {
            persons: false,
            reasons: false,
            providers: false,
            appointmentresources: false,
            pets: false,
            trackableItems: false,
        };
        $scope.viewModel.executeIsEnabled = false;
        $scope.dialog = $uibModalInstance;
        function checkToWipe() {
            for (var i in $scope.viewModel.toWipe) {
                if ($scope.viewModel.toWipe[i]) {
                    return true;
                }
            }
            return false;
        }
        var interval = null;
        $scope.changeSwitch = function () {
            console.log($scope.viewModel.executeIsEnabled, interval);
            if (!$scope.viewModel.executeIsEnabled) {
                if (interval) {
                    clearInterval(interval);
                    interval = null;
                }
                $scope.timeToDisable = loadTime;
                return;
            }
            interval = setInterval(function () {
                if ($scope.timeToDisable === 0) {
                    clearInterval(interval);
                    interval = null;
                    $scope.viewModel.executeIsEnabled = false;
                    $scope.timeToDisable = loadTime;
                    return;
                }
                $scope.timeToDisable--;
            }, 1000);
        };
        $scope.execute = function () {
            $scope.viewModel.executeIsEnabled = false;
            $scope.changeSwitch();
            if (!checkToWipe()) {
                return;
            }
            accountService.wipeAccount($scope.userId, $scope.userName, $scope.viewModel.toWipe, $scope.viewModel.loadingIndicator)
                .then(function () {
                $scope.dialog.close(undefined);
            });
        };
    }]);
//# sourceMappingURL=users.controllers.js.map